import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Select from 'react-select'

import { getTags, getIsFetchingTags } from 'redux/reducers'
import { loadTags } from 'redux/actions'

import 'react-select/dist/react-select.css'
import './index.css'

class TagSelect extends Component {
  constructor (props) {
    super(props)

    this.getAvailableTags = this.getAvailableTags.bind(this)
  }

  componentWillMount () {
    const { isFetchingTags, loadTags, tags } = this.props

    if (!tags.length && !isFetchingTags) {
      loadTags()
    }
  }

  getAvailableTags (formTags, tags) {
    return tags.filter(tag => !formTags || !formTags.find(id => tag.id === id)
    )
  }

  render () {
    const {
      fields,
      tags,
      id,
      className,
      name,
      helpText,
      placeholder,
      onChange
    } = this.props

    const formTags = fields.map((member, index) => fields.get(index))

    return (
      <div className='tag-select-container'>
        <Select
          id={id}
          className={className}
          name={name}
          placeholder={placeholder}
          onChange={(e) => onChange(e.id)}
          labelKey='name'
          valueKey='id'
          options={this.getAvailableTags(formTags, tags)}
        />
        <div className='tag-select-help-message'>
          { helpText }
        </div>
      </div>
    )
  }
}

TagSelect.propTypes = {
  tags: PropTypes.array.isRequired,
  isFetchingTags: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => ({
  tags: getTags(state),
  isFetchingTags: getIsFetchingTags(state)
})

export default connect(mapStateToProps, { loadTags })(TagSelect)



// WEBPACK FOOTER //
// ./src/containers/TagSelect/index.js